<template>
  <div class="content-container">
    <b-container fluid>
      <b-row class="pt-3">
        <b-col cols="12">
          <h2>{{$t('keywordAnalysisTable.title')}}</h2>
        </b-col>
      </b-row>
      <b-row class="mt-3 pb-3">
        <b-col cols="12">
          <b-table
            :fields="fields"
            :items="keywordAnalysis.keywordsFound"
            :current-page="currentPage"
            :per-page="perPage"
            outlined
            show-empty
            striped
          >
            <template v-slot:empty="scope">
              <p>{{$t('keywordAnalysisTable.tableEmpty')}}</p>
            </template>

            <template v-slot:head(keyword)>
              {{$t('keywordAnalysisTable.tableKeyword')}}
            </template>

            <template v-slot:cell(keyword)="data">
              <p class="mb-0">
<!--                {{data.item.previousWords}}-->
                <b class="danger-color">{{data.item.keyword}}</b>
<!--                {{data.item.followingWords}}-->
              </p>
            </template>

            <template v-slot:head(actions)>
              {{$t('keywordAnalysisTable.tableActions')}}
            </template>

            <template v-slot:cell(actions)="data">
              <span
                class="fa fa-play hover hover-primary"
                @click="playKeyword(data.item)"
              ></span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: mapState({
      keywordAnalysis: state => state.keywordAnalysis.keywordAnalysis,
    }),
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        fields: [
          'keyword',
          'actions',
        ],
      };
    },
    methods: {
      playKeyword(keywordInfo) {
        this.$store.dispatch('keywordAnalysis/setDesiredTime', keywordInfo.startTime);
      },
    },
  };
</script>

<style scoped>

</style>
